module.exports = __webpack_public_path__ + "img/menu_home.c00ee383.svg";